import $ from 'jquery';
import _ from 'lodash';

const SUCCESS_SELECTOR = '.card-shopping-cart';
const LIMIT_SELECTOR = '.card-shopping-limit';
const CART_BADGE_HOST_SELECTOR = '[data-shoppingcart]';

const $popup = () => $(SUCCESS_SELECTOR);
const $limitPopup = () => $(LIMIT_SELECTOR);
const $cartHost = () => $(CART_BADGE_HOST_SELECTOR);
const $badge = () => $cartHost().find('.badge');

const closePopup = _.debounce((view) => {
    if (view.is($cartHost())) {
        $badge().removeClass('bounce is-animate');
    }
    view.removeClass('items-added');
}, 3000);

const triggerPopup = (view, count) => {
    if ($badge().hasClass('is-animate')) return;
    view.addClass('items-added');
    if (count !== undefined) {
        $('.shopping-cart-count').text(count);
    }
    closePopup(view);
};

const renderProductImage = (imageUrl) => {
    if (!imageUrl) return;
    const existing = document.querySelector('.js-popup-shopping-cart-image');
    if (existing) {
        existing.src = imageUrl;
        return;
    }
    const html = `
        <div class="col-auto mb-2">
            <div class="card">
                <img class="js-popup-shopping-cart-image" src="${imageUrl}" alt="product" style="width: 100px;">
            </div>
        </div>
    `;
    $('.js-popup-shopping-cart-content-container').prepend(html);
};

const positionPopup = (view) => {
    let visibleCart = null;
    $cartHost().each(function () {
        const $cart = $(this);
        if ($cart.offset().top > 0) {
            visibleCart = $cart;
        }
    });
    if (visibleCart) {
        view.css('top', (visibleCart.offset().top - $(window).scrollTop()) + visibleCart.outerHeight() + 1);
        view.css('left', visibleCart.offset().left + visibleCart.outerWidth() - view.outerWidth());
    }
};

export const show = ({partNumber, price, count, productName, productType, imageUrl} = {}) => {
    if (productName !== undefined) {
        $('.product-name').html(productName);
    }
    if (productType !== undefined) {
        $('.product-type').html(productType);
    }
    if (partNumber !== undefined) {
        $('.product-id').text(partNumber);
    }
    if (price !== undefined) {
        $('.product-price').text(price);
    }
    if (count !== undefined) {
        $('.shopping-cart-count').text(count);
    }
    renderProductImage(imageUrl);
    triggerPopup($popup(), count);
};

export const showOrderLimit = () => {
    triggerPopup($limitPopup());
};

export const showCartTotalLoader = () => {
    $('.shopping-cart-total').html('<i class="fa fa-spinner fa-spin"></i>');
};

const wirePopup = ($view) => {
    if (!$view.length) return;
    positionPopup($view);
    $view.on('mouseover', () => triggerPopup($view));
    $(window).on('resize', () => positionPopup($view));
};

export const register = () => {
    if (!$cartHost().length) return;
    wirePopup($popup());
    wirePopup($limitPopup());

    const $popupView = $popup();
    if ($popupView.length) {
        $('.close_cart').on('click', (e) => {
            $badge().removeClass('bounce is-animate');
            $popupView.removeClass('items-added');
            e.preventDefault();
        });
    }
};

export default {show, showOrderLimit, showCartTotalLoader, register};
